import { useClinicianContext } from 'lib/hooks/use-resolveCurrentClinicInfo';

export function useIsInImPACTClinic() {
  const clinicianContext = useClinicianContext();
  return clinicianContext.clinicNames
    .at(
      clinicianContext.clinicIds.findIndex(
        _ => clinicianContext.currentClinic === _
      )
    )
    ?.toLowerCase()
    .includes('impact');
}
